<template>
<div class="tool-page">
  
<div class="tools-base" >
    <div class="containner">
      <!-- banner 图 -->
      <div class="banner">
        <img src="../../assets/imgs/banner.png" alt="致远产品工具库">
        <p class="banner-info">提供丰富的开发、测试、运维工具，辅助您更高效地进行定制开发、功能测试、实施运维</p>
      </div>
      <!-- 热门工具 -->
      <HotTools
        :list="hotToolsList"
        @toDetail="handleToDetail"
        @verify="handleDownload"
        v-if="!isMobile"
      ></HotTools>
      <!-- 工具分类 -->
      <div class="tools-list-area" v-if="categoriesList.length && !isMobile">
        <CategoriesList
          :categoryObj="item"
          v-for="item in categoriesList"
          :key="item.id"
          @toDetail="handleToDetail"
          @verify="handleDownload"
        ></CategoriesList>
      </div>
      <div class="mobile" v-if="isMobile">
        <span>详细信息请去PC端查看</span>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <a-modal
      class="detail-modal"
      v-model="isDetailModalVisible"
      :footer="false"
      centered
      width="80%"
      :zIndex="999"
      :bodyStyle="{ height: '90vh', overflowY: 'auto', padding: '40px' }"
      destroy-on-close
    >
      <Detail :toolObj="curTool" @vertify="(url) => { handleDownload(url) }"></Detail>
    </a-modal>
    <!-- 验证码弹窗 -->
    <a-modal
      class="code-modal"
      v-model="isCodeModalVisible"
      :footer="false"
      destroyOnClose
      @afterClose="handleClose"
    >
      <Code
        :imageCode="imageCode"
        @change="getImageCode"
        @verify="verify"
      ></Code>
    </a-modal>
    <!-- 问题反馈 -->
    <FeedBack></FeedBack>
  </div>
  <!-- <div v-else>
    <Login @loginSuccess="loginSuccess" :isShare="true"/>
  </div> -->
</div>
  
</template>

<script>
import CategoriesList from "./cmps/CategoriesList.vue";
import HotTools from "./cmps/HotTools.vue";
import Detail from "./cmps/Detail.vue";
import Code from "./cmps/Code.vue";
import FeedBack from "../FeedBack.vue";
// import Login from '@/components/login/Login'
import {
  // getCategories,
  getHotTools,
  getToolById,
  downloadTool,
  getImageCode,
} from "../../api/tools";
import axios from 'axios';
// import eventBus from '@/utils/eventBus'

export default {
  name: "tools-base",
  components: {
    CategoriesList,
    HotTools,
    Detail,
    Code,
    FeedBack,
    // Login
  },
  data() {
    return {
      navList: [
        {
          key: "home",
          title: "首页",
          link: "http://open.seeyon.com/",
        },
        {
          key: "faq",
          title: "FAQ",
        },
        {
          key: "doc",
          title: "文档",
          link: "http://open.seeyon.com/book/",
        },
        {
          key: "toolbase",
          title: "工具库",
        },
        {
          key: "projects",
          title: "项目管理",
          link: "#",
        },
        {
          key: "forum",
          title: "论坛",
          link: "http://open.seeyon.com/seeyonbbs/",
        },
      ],
      categoriesList: [],
      hotToolsList: [],
      isDetailModalVisible: false,
      curTool: {},
      isCodeModalVisible: false,
      imageCode: "",
      imageKey: "",
      curUrl: "",
      isMobile: false,
      // loginKey: "",
      // isLogin: false
    };
  },
  created() {
    if (this.$route.params && this.$route.params.toolId) {
      this.handleToDetail(this.$route.params.toolId, 2);
      this.isDetailModalVisible = true;
    } else if (this.$route.params && this.$route.params.downloadUri) {
      var uri = JSON.parse(JSON.stringify(this.$route.params.downloadUri));
      this.handleDownload(uri);
    }

    // eventBus.$on("loginSuccess", () => {
    //   this.loginKey = sessionStorage.getItem("loginKey");
    // })

    // // 判断用户是否登录过
    // this.loginKey = sessionStorage.getItem("loginKey");
    // if (this.loginKey) {
    //   this.isLogin = true
    // }

    this.outerToTools(); // 外部分享链接跳转工具库 

    // this.getCategoriesList();
    this.getHotToolsList();

    this.isMobileFn();
  },
  methods: {
    isMobileFn() {
      let userAgentInfo = navigator.userAgent;
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));

      this.isMobile = getArr.length ? true : false;
    },

    // 外部分享链接跳转工具库 
    outerToTools() {
        if (!this.$outerToolsLink) {
            return;
        }

        const outerLink = this.$outerToolsLink.replace("toolbase?shareUrl=/", "");
        axios({
            url: outerLink
        }).then(res => {
            if (res && res.data && res.data.data) {
                // 当typeId为0 时，是热门工具，不需要typeId
                this.handleToDetail(res.data.data.id, res.data.data.typeId ? res.data.data.typeId : null )
            } else {
                this.$error({ title: "获取工具库详情失败！" });
            }
        }, err => {
            console.log("tools error:", err)
        })
    },
    // getCategoriesList() {
    //   getCategories().then((res) => {
    //     try {
    //       if (res && res.code == 200) {
    //         if (res.data) {
    //           this.categoriesList = res.data;
    //         }
    //       }
    //     } catch (error) {
    //       this.$error({ title: error });
    //     }
    //   });
    // },
    getHotToolsList() {
      getHotTools().then((res) => {
        try {
          if (res && res.code == 200) {
            if (res.data) {
              this.hotToolsList = res.data;
            }
          }
        } catch (error) {
          this.$error({ title: error });
        }
      });
    },
    handleToDetail(id, toolType) {
      var type = toolType;
      if (type == undefined || type == null) {
        type = "HOT";
      }
      if (id !== undefined && id !== null) {
        this.getTool(type, id);
      }
    },
    getTool(type, id) {
      getToolById(type, id).then((res) => {
        try {
          if (res.data) {
            this.curTool = res.data;
            this.isDetailModalVisible = true;
          }
        } catch (error) {
          this.$error({
            title: error.message,
          });
        }
      });
    },
    getImageCode(isChange) {
      getImageCode().then((res) => {
        if (res && res.code == 200) {
          if (res.data) {
            if (res.data.verify) {
              this.imageCode = res.data.imageBase64 || "";
              this.imageKey = res.data.imageKey || "";
              this.isCodeModalVisible = true;
            } else {
              if (!isChange) {
                downloadTool(this.curUrl).then((res) => {
                  if (res && res.data) {
                    console.log("下载", res.data);
                    window.location.href = res.data;
                  }
                });
              }
            }
          }
        }
      });
    },
    handleDownload(url) {
      this.curUrl = url;
      this.getImageCode();
    },
    verify(imageCode) {
      if (!imageCode) {
        this.$warning({ title: "请输入验证码！" });
        return;
      }
      var imageKey = this.imageKey;
      downloadTool(this.curUrl, { imageCode, imageKey }).then((res) => {
        if (res && res.code == 200) {
          if (res.data) {
            window.location.href = res.data;
          } else {
            this.$error({
              title: "下载地址不存在！",
            });
          }
          this.isCodeModalVisible = false;
        }
      });
    },
    handleClose() {
      this.curUrl = "";
      this.imageCode = "";
      this.imageKey = "";
    },
    // loginSuccess() {
    //   this.isLogin = true;
    // }
  },
  watch: {},
};
</script>

<style lang="scss" >
.containner {
  width: 100%;
  height: calc(100% - 88px);
}
.banner {
    position: relative;
}
.banner img {
  width: 100%;
}
.banner-info {
  position: absolute;
  left: 5%;
  top: 50%;
  // top: 200px;
  // left: 100px;
  font-size: 20px;
    // width: 520px;
}
.tools-list-area {
  padding-top: 80px;
  margin: 0 auto;
}
/** 公共样式 */
.tools-list-header {
  width: 100%;
  text-align: center;
}
.title-row {
  position: relative;
}
.title-sub {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -40%);
  display: inline-block;
  z-index: 0;
  font-family: PangMenZhengDao;
  font-weight: 500;
  font-size: 64px;
  color: #f0f0f0;
  letter-spacing: 1.6px;
}
.list-title {
  position: relative;
  z-index: 1;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  letter-spacing: 1px;
}
.description {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 22px;
  color: #666666;
  letter-spacing: 0.55px;
  padding: 0 5px;
}
.mobile {
  display: flex;
  text-align: center;
  font-size: 18px;
  padding-top: 20px;
  display: flex;
  justify-content: center;
  font-weight: 700;
  padding-top: 50%;
}
@media screen and (max-width: 1024px) {
  .banner-info {
    font-size: 18px;
  }
}
@media screen and (max-width: 767px) {
  .banner-info {
    font-size: 16px;
  }
}
@media screen and (max-width: 560px) {
  .banner-info {
    font-size: 14px;
  }
}
@media screen and (max-width: 460px) {
  .banner-info {
    font-size: 12px;
  }
}
</style>
